import { ActivatedRouteSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { VenueQuoteService } from './venue-quote.service';
import { VenueQuoteModel } from './venue-quote.model';

@Injectable({
  providedIn: 'root',
})
export class VenueQuoteResolver {
  constructor(private service: VenueQuoteService) {}

  resolve(route: ActivatedRouteSnapshot): Observable<VenueQuoteModel> {
    const id = route.paramMap.get('id') || '';

    return this.service.getById(id).pipe(map((response) => response.data));
  }
}
